import { FC, useState } from 'react';

import { Button, Text } from '@/components';
import { ModalPropTypes } from '@/layouts/Modal';
import { ProductItemPropTypes } from '@/components/Card/Product';
import { useCart } from '@/context/cartContext';
import { useCallback } from 'react';

const RemoveItem: FC<ModalPropTypes & ProductItemPropTypes> = ({
  onClose,
  item_id,
  quote_id,
  sku,
  qty,
  name,
  ...rest
}) => {
  const { removeFromCart } = useCart();
  const [loading, setLoading] = useState(false);

  const onRemove = useCallback(async () => {
    setLoading(true);
    await removeFromCart({ item_id, quote_id, sku, qty, name });
    setLoading(false);
    onClose();
  }, [
    sku,
    rest,
    removeFromCart,
    item_id,
    quote_id,
    qty,
    name,
    onClose,
    setLoading,
  ]);

  return (
    <div aria-label='remove-item' className='space-y-6'>
      <Text className='p-0'>
        Are you sure you want to remove “{name}” from the cart?
      </Text>

      <div className='grid grid-cols-1 gap-3 md:grid-cols-2'>
        <Button
          label='Yes, Remove'
          onClick={onRemove}
          className='max-md:py-[0.94rem] disabled:bg-fig'
          isLoading={loading}
          disabled={loading}
        />

        <Button
          onClick={onClose}
          disabled={loading}
          label='No, Keep in Cart'
          variant='secondary'
          className='max-md:border-0 max-md:py-[0.94rem] max-md:underline'
        />
      </div>
    </div>
  );
};

export default RemoveItem;
